import { MyErrorHandler } from '../../../../tools/src/lib/errorhandler/errorhandler';
import { UtilserviceService } from '../../../../contentmanagement/src/app/service/utilservices/utilservice.service';
import { AddnewGroup } from './classes/addnewgroup';
import { GroupSessionData } from './classes/groupsessiondata';
import { ManagegroupserviceService } from './managegroupservice.service';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as languageConfig from '../../../../../src/assets/i18n/configuration/configuration.json';

import { environment } from '../../environments/environment';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';

import { TabGroup } from '@eds/vanilla';
import { Dialog } from '@eds/vanilla';
//import { ToolsService } from 'projects/tools/src/public-api';
import { ToolsService } from '../../../../tools/src/lib/tools.service';

@Component({
  selector: 'app-manage-groups',
  templateUrl: './manage-groups.component.html',
  styleUrls: ['./manage-groups.component.css'],
  providers: [ManagegroupserviceService, UtilserviceService, ToolsService]
})
export class ManageGroupsComponent implements OnInit, AfterViewInit {

  groupForm: FormGroup;
  groupDetailsData: any;
  studentList: any[];
  tempGroupName: any;
  groupId: any;
  loaded = false;
  @ViewChild('groupCreateSuccesModal') groupCreateSuccesModal: ElementRef;
  @ViewChild('groupCreateModel') groupCreateModel: ElementRef;
  @ViewChild('groupDeleteConifrmModal') groupDeleteConifrmModal: ElementRef;
  @ViewChild('studentDetailsModal') studentDetailsModal: ElementRef;
  @ViewChild('groupDetailsModel') groupDetailsModel: ElementRef;


  public studentDetails;
  errorHandler: MyErrorHandler;
  groupListData: any;
  duplicateNameMSg: any;
  showLoader: any;
  deleteGroupId: any;
  groupListCount = 0;
  environment;
  btnTextEdit = '';
  isAllSelected = false;
  isAllDeSelected = false;

  public studentListData;
  groupStudents = [];
  _sessionData: any;
  classID: any;

  titleMessage = '';
  subTitleMessage = '';
  detailMessage = '';
  detailMessage1 = '';
  gridViewS = true;
  gridViewG = true;

  public filterQuery = '';
  public rowsOnPage = 10;

  page = 1;
  noOfItems = 9;

  public addNewGroup;
  public isUpdateGroup: boolean;

  isStudentExists = true;
  isGroupExists = false;

  public isListView = false;
  public isGridView = true;

  btnSave = 'Add';
  btnSaveStatus = true;
  btnCancel = '';
  btnSend = '';

  gridSelectedGroup = true;
  gridSelectedStudent = true;

  groupModalTitle = '';
  groupModalInfo = '';
  curView = 'read';
  editlink = '';
  deleteText = '';
  iconColor = {
    stringToColorHash: {},
    nextVeryDifferntColorIdx: 1,
    veryDifferentColors: ['#89ba17', '#89ba17']
  };

   /* Sorting variables */
   propertyName: string;
   propertyNameSorting: string;
   orderType = true;
   isSorted = false;
   sortedClass: string;
  textDir:any;
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private manageGroupService: ManagegroupserviceService,
    private utilserviceService: UtilserviceService,
    private translate:TranslateService,
    private util: ToolsService) {
    this.addNewGroup = new AddnewGroup();
    this.isUpdateGroup = false;
    this.textDir = sessionStorage.getItem('textDir');
  }


  ngOnInit() {
    this.environment = environment;
    this.groupForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(40)]],
      description: ['', [Validators.maxLength(120)]],
      class_id: [''],
      students: ['']
    });
    if (localStorage.getItem('token')) {
      this._sessionData = JSON.parse(localStorage.getItem('sessionDataForClass'));
      this.classID = this._sessionData._id;
      if (JSON.parse(localStorage.getItem('sessionDataForGroup'))) {
        localStorage.setItem('sessionDataForGroup', null);
        this.getGroupListData();
        this.invokeStudentListService(this.classID);
      } else {
        this.invokeStudentListService(this.classID);
      }
      return true;
    }
    this.router.navigate(['/login']);
  }

  ngAfterViewInit(){
    this.tabInit();
  }

  getStudentDetails(userId) {
    return this.utilserviceService.getUserDetails(userId).subscribe(
      (response) => {
        this.studentDetails = response;
        if (this.studentDetails != null) {
          this.btnCancel = 'Close';
          this.btnSave = '';
          this.btnSend = '';
          // jQuery('#userModal').modal('show');
          this.openDialogModal('userModal');
        }
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }else{
          this.openServerErrorDialog();
        }
      },
      () => {
        console.log('COMPLETED');
      }
    );
  }

  /***
     * this method will be used to invoke service layer to get student List according to classID
   */
  invokeStudentListService(classId) {
    this.showLoader = true;
    return this.manageGroupService.getClassStudentListData(classId).subscribe(
      (response) => {
        if (response != null && response.length > 0) {
          this.studentListData = response;
          console.log("studentListData JANI >>>> "+JSON.stringify(response))
          this.getGroupCount(classId);
        }
        this.isStudentExists = true;
        this.isGroupExists = false;
        this.showLoader = false;
        return;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }else{
          this.openServerErrorDialog();
        }
      },
      () => {
        this.showLoader = false;
        console.log('COMPLETED');
        this.tabInit();
      }
    );
  }

  getGroupCount(classId){
   return this.manageGroupService.getClassGroupListData(classId).subscribe(
      (response) => {
        if (response != null && response.length > 0) {
          this.groupListCount = response.length;
          return;
        }
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }else{
          this.openServerErrorDialog();
        }
      },
      () => {
        this.showLoader = false;
        console.log('COMPLETED');
      }
    );
  }

  /***
     * this method will be used to invoke service layer to get Group List with student information according to classID
   */
  invokeGroupListService(classId) {
    this.showLoader = true;
    this.groupListData = null;
    return this.manageGroupService.getClassGroupListData(classId).subscribe(
      (response) => {
        if (response != null && response.length > 0) {
          this.groupListData = response;
          this.groupListCount= this.groupListData.length;
          
        } else {
          // $('#infoButtonId').css('display', 'none');
        }
        this.showLoader = false;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
        }else{
          this.openServerErrorDialog();
        }
      },
      () => {
        this.showLoader = false;
        console.log('COMPLETED');
      }
    );
  }


  /***
   * this method will be used to invoke service layer to add new group with student
   * @param groupData -> contains group data
   */
  invokeCreateGroupService(groupData) {
    return new Promise<void>((resolve, reject) => {
    this.showLoader = true;
    this.manageGroupService.createGroup(groupData).subscribe(
      (response) => {
        this.showLoader = false;
        this.titleMessage = this.translate.instant('Group created');
        this.subTitleMessage = groupData.name.charAt(0).toUpperCase() +  groupData.name.slice(1);
        this.detailMessage = '';
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
        else{
          this.openServerErrorDialog();
        }
        reject();
      },
      () => {
        this.showLoader = false;
        this.getGroupCount(this.classID);
        console.log('COMPLETED');
        resolve();
      }
    );
    });
  }


  /***
      * this method will be used to update a group
    */
  invokeUpdateGroupService(groupId, groupData) {
    return new Promise<void>((resolve, reject) => {
      this.showLoader = true;
      this.manageGroupService.updateGroup(groupId, groupData).subscribe(
        (response) => {
          this.titleMessage = this.translate.instant('Group updated');
          this.subTitleMessage = this.groupDetailsData.name.charAt(0).toUpperCase() + this.groupDetailsData.name.slice(1);
          this.detailMessage = '';
          this.closeDialogModal('groupModal');
          this.openDialogModal('successModal');
        },
        (err) => {
          const errorHandlerObj = new MyErrorHandler();
          this.errorHandler = errorHandlerObj.handleError(err);
          if (this.errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }else{
            this.openServerErrorDialog();
          }
          reject();
        },
        () => {
          this.showLoader = false;
          console.log('COMPLETED');
          resolve();
        }
      );
    });
  }

  /***
      * this method will be used to delete a group
    */
  invokeDeleteGroupService(groupId) {
    this.showLoader = true;
    return this.manageGroupService.deleteGroup(groupId).subscribe(
      (response) => {
        this.showLoader = false;
        this.closeDialogModal('groupDeleteConifrmModal');
        this.titleMessage = this.translate.instant('Group deleted');
        this.subTitleMessage = this.groupDetailsData.name.charAt(0).toUpperCase() + this.groupDetailsData.name.slice(1);
        this.openDialogModal('successModal');
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }else{
          this.openServerErrorDialog();
        }
      },
      () => {
        this.getGroupListData();
        this.showLoader = false;
        console.log('COMPLETED');
      }
    );
  }

  /***
      * this method will be used to invoke the service to get the student list
    */
  getStudentListData() {
    this.invokeStudentListService(this.classID);
    this.isStudentExists = true;
    this.isGroupExists = false;
    this.rowsOnPage = 10;
  }

  /***
    * this method will be used to display the confirmation message modal for delete
  */
  deleteGroup() {
    this.deleteGroupId = this.groupDetailsData._id;
    this.closeDialogModal('groupModal');
    this.titleMessage = this.translate.instant('Delete this group?')
    this.openDialogModal('groupDeleteConifrmModal');
  }

  /***
    * this method will be used to invoke the service to get the group list
  */
  getGroupListData() {
    this.invokeGroupListService(this.classID);
  
    this.isStudentExists = false;
    this.isGroupExists = true;

    this.rowsOnPage = 6;
  }

  /***
      * this method will be used to change the appearance to grid view
    */
  changeListToGridView() {
    this.isGridView = true;
    this.isListView = false;
  }

  /***
    * this method will be used to change the appearance to list view
     */
  changeGridToListView() {
    this.isGridView = false;
    this.isListView = true;
  }


  /***
    * this method will be used to display the add new group modal
  */
  createNewGroupModel() {
    this.isAllSelected = false;
    this.isAllDeSelected = false;
    this.isUpdateGroup = false;
    this.groupId = null;
    this.addNewGroup = new AddnewGroup();
    if (this.studentListData) {
      this.studentListData = JSON.parse(JSON.stringify(this.studentListData));
    }
    this.groupStudents = new Array();
    this.groupForm.reset();
    this.curView = 'add';
    this.groupModalTitle = this.translate.instant('Add a new group');
    this.groupModalInfo = '';
    this.btnSave = this.translate.instant('Add');
    this.btnCancel = 'Cancel';
    this.btnSaveStatus = true;
    this.editlink = '';
    this.deleteText = '';
    this.openDialogModal('groupModal');
  }


  /***
      * this method will be used to validate for duplicate group names and invoke service to create new group
    */
  createNewGroup() {
    if (!this.groupListData || this.groupListData.filter(x => x.name.toLowerCase() === this.addNewGroup.name.toLowerCase()).length === 0) {
      this.addNewGroup.class_id = this.classID;
      this.invokeCreateGroupService(this.addNewGroup).then(() => {
        this.refreshGroupData();
        this.closeDialogModal('groupModal');
        this.titleMessage = this.translate.instant('Group created');
        this.subTitleMessage = this.addNewGroup.name.charAt(0).toUpperCase() +  this.addNewGroup.name.slice(1);

        //this.subTitleMessage = this.addNewGroup.name;
        this.detailMessage = '';
        this.openDialogModal('successModal');
      });
    } else {
      this.duplicateNameMSg = this.translate.instant('Duplicate group name');
      this.titleMessage = this.duplicateNameMSg;
      this.detailMessage = this.translate.instant('Please enter unique group name.');
      this.openDialogModal('errorModal');
    }
  }



  /***
    * this method will be used to record the keypress of group name
  */
  onKeyPress() {
    this.duplicateNameMSg = null;
  }



  /***
      * this method will be used to display the respective group details
    */
  groupDetails(groupData) {
    this.groupDetailsData = new Array();
    this.groupDetailsData = groupData;
    this.btnCancel = 'Close';
    this.btnSave = '';
    this.btnSend = '';
    this.curView = 'read';
    this.editlink = 'yes';
    this.deleteText = this.translate.instant('Delete');
    this.btnTextEdit = this.translate.instant('Edit');
    this.groupModalTitle = groupData.name;
    this.groupModalInfo = this._sessionData.name;
    this.btnSaveStatus = false;
    this.openDialogModal('groupModal');
  }



  /***
      * this method will be used to display the edit modal with the earlier values
    */
  updateGroupModel() {
    this.isAllSelected = false;
    this.isAllDeSelected = false;
    this.groupId = this.groupDetailsData._id;
    this.addNewGroup = new AddnewGroup();
    this.addNewGroup.class_id = this.classID;
    this.addNewGroup.name = this.groupDetailsData.name;
    this.tempGroupName = this.groupDetailsData.name;
    this.addNewGroup.description = this.groupDetailsData.description;

    this.isUpdateGroup = true;
    this.groupForm.get('name').patchValue(this.groupDetailsData.name);
    this.groupForm.get('description').patchValue(this.groupDetailsData.description);
    this.groupStudents = new Array();
    this.groupDetailsData.students.forEach(element => {
      this.groupStudents.push(element._id);
    });

    this.btnCancel = 'Cancel';
    this.btnSave = 'Save';
    this.btnSend = '';
    this.curView = 'edit';
    this.btnTextEdit = '';
    this.editlink = '';
    this.deleteText = '';
    this.openDialogModal('groupModal');
  }


  /***
     * this method will be used to invoke the service to update group details
     */
  updateGroup() {
    this.addNewGroup.class_id = this.classID;
    console.log(this.addNewGroup);
    this.invokeUpdateGroupService(this.groupId, this.addNewGroup).then(() => this.refreshGroupData());
    return;
  }


  /***
     * this method will be used to get the updated group list
     */
  refreshGroupData() {
    this.getGroupListData();
  }


  /**
   * Method to add all student Id in student list . If user click all select
   */
  selectAll() {
    console.log('inside select all');
    this.isAllSelected = true;
    this.isAllDeSelected = false;
    this.addNewGroup.students = new Array();
    for (var index = 0; index < this.studentListData.length; index++) {
      this.studentListData[index].isExit = true;
      this.addNewGroup.students.push(this.studentListData[index]._id);
    }
  }

  /*
   * Method to remove all student Id in student list . If user click all de-select
   */
  DeSelectAll() {
    console.log('inside De select all');
    this.isAllSelected = false;
    this.isAllDeSelected = true;
    for (var index = 0; index < this.studentListData.length; index++) {
      this.studentListData[index].isExit = false;
    }
    this.addNewGroup.students = new Array();
  }


  /***
    * this method will be used to add or remove students from groups
    */
  toggleSelection(studentId) {
    const idx = this.addNewGroup.students.indexOf(studentId);
    console.log(studentId);
    // Is currently selected
    if (idx > -1) {
      this.addNewGroup.students.splice(studentId, 1);
    }
    // Is newly selected
    else {
      this.addNewGroup.students.push(studentId);
    }
    console.log('Student List', this.addNewGroup.students);
  }

  /*
 *  code for show possible error in notification form
 */
  showErrorBox() {
    this.showLoader = false;
    const className = document.getElementById('snack-error-bar');
    className.className = 'show';
  }
  downloadCsv(data, type){
    this.util.generateCSV(data, type);
  }
  /*
 *  code for close snack notification bar
 */
  closeErrorDiv() {
    const className = document.getElementById('snack-error-bar')
    className.className = className.className.replace('show', '');
  }

  /***
    * this method will be used to display the student details
  */
  displayStudentDetails(userId) {
    console.log('Student ID', userId);
    this.getStudentDetails(userId);
  }

  setGrid(utype) {
    if (utype === 'student'){
      this.getStudentListData();
      this.gridSelectedStudent = true;
      this.gridViewS = true;
    }else{
      this.getGroupListData();
      this.gridSelectedGroup = true;
      this.gridViewG = true;
      this.noOfItems = 18;
    }
   }
   setList(utype) {
    if (utype === 'student'){
      this.getStudentListData();
      this.gridSelectedStudent = false;
      this.gridViewS = false;
    }else{
      this.getGroupListData();
      this.gridSelectedGroup = false;
      this.gridViewG = false;
      this.noOfItems = 18;
    }
   }

   saveGroupData() {
     ///
     this.addNewGroup = new AddnewGroup();
     this.addNewGroup = this.groupForm.value;
     if (this.groupId) {
       this.updateGroup();
     } else {
       if (!this.addNewGroup.name || this.addNewGroup.name === null) {
       } else {
         this.createNewGroup();
       }
    }
     // add validation
   }

   formChange() {
     if (this.groupForm.get('name').value &&
       this.groupForm.get('description').value ) {
         console.log("studentform >>");
        console.log(this.groupForm.get('students'));
        this.btnSaveStatus = false;
      } else {
        this.btnSaveStatus = true;
      } 
   }
   checkStatus(flag){


   
    this.btnSaveStatus = false;
      
      if (flag) {
        this.btnSaveStatus = false;
      } else {
        this.btnSaveStatus = true;
      }
    
    

   }
   closeModal(mid) {
    // jQuery('#' + mid).modal('hide');
    this.closeDialogModal(mid);
   }

  tabInit(){
    const tabs = document.querySelectorAll('.tabs');
    if (tabs) {
      Array.from(tabs).forEach(tabGroup1 => {
        const tabGroup = new TabGroup(tabGroup1 as HTMLElement);
        tabGroup.init();
      });
    }
  }

  openDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.show();
  }

  closeDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.hide();
  }

  /* Sorting functionality added - KAJAL */
  sortByDefault(propertyName){
    this.isSorted = true;
    this.sortedClass = '';
    this.propertyName = propertyName;
    this.orderType = true;
    this.propertyNameSorting = propertyName;
  }
  sortBy(propertyName){
    this.isSorted = true;
    this.sortedClass = '';
    this.propertyName = propertyName;
    if (propertyName !== null && this.propertyName === propertyName){
      if (this.orderType === true){
        this.orderType = false;
        this.propertyNameSorting = propertyName;
        this.sortedClass = 'asc';
      }else{
        this.orderType = true;
        this.propertyNameSorting = '-' + propertyName;
        this.sortedClass = 'desc';
      }
    }
  }
  openServerErrorDialog(){
    this.titleMessage = this.translate.instant('Server or network error');
    this.detailMessage = this.translate.instant('A server or network error has occurred. Please try again later.');
    this.detailMessage1 = this.translate.instant('If this error persists contact your system administrator.');
    this.openDialogModal('errorModal');
  }
}
